import React, { Component } from 'react';
import { NavLink, Navigate } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Tooltip from '@mui/material/Tooltip';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Sendemail from './Sendemail';
import Columnsettings from './Columnsettings';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle'; 
import psdfimage from './images/psdfimage.png';



const styles = {
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
};

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (!Array.isArray(array)) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export default class Salesdaybookreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sestatus: '',
      isselectdisplay: false,
      open: false,
      currentDate: new Date(),
      month1: '',
      lastDayOfMonth: '',
      lastDay: '',
      todate1: '',
      todate: '',
      fromdate: '',
      fromdate1: '',
      salesbookData: [], 
      totaldata:0,
      type: 0,
      redirect: false,
      pagename: '',
      id: '',
      page: 0,
      prevpage: 0,
      rowsPerPage: 50,
      rowsPaging: [],
      quotenumber: '',
      contactname: '',
      search: '',
      order: 'desc',
      orderBy: 'sin_id',
      iconslist: false,
      allchecked: false,
      showSummary: true, 
      fromDateEnabled: false,
      toDateEnabled: false,
	  openExportDialog: false,
	  salesdetailsbookData:[],ExportData:[],pdflogo:'',
    };
    this.todatehandler = this.todatehandler.bind(this);
    this.fromdatehandler = this.fromdatehandler.bind(this);
   ; 
  }

  componentWillMount() {
    document.title = 'Isifol - Sales Tax report';
    if (localStorage.getItem('ISIuserid') == null) {
      this.setState({
        redirect: true,
        pagename: '/Login',
      });
    }
    this.props.parentdasCallback('Sales Tax Report~');
    this.apicall(this.state.page, this.state.rowsPerPage);
  }

  apicall(page, rowsPerPage) {
    axios.get(localStorage.getItem('ISIurl') + 'ajaxreports.php?action=salestaxreport&fromdate=' +this.state.fromdate1+'&todate='+this.state.todate1+ '&StartIndex=' + page + '&PageSize=' + rowsPerPage+'&cmp_id='+ localStorage.getItem('ISIcmpid'))
      .then((resp) => {
        if (resp.data && resp.data.length > 0) {
          let copy = [50, 100, 150, 200, 250];
          this.setState({
            salesbookData: resp.data, 
            totaldata: parseInt(resp.data[0].count),
            rowsPaging: copy,
          });
        } else {
          this.setState({ salesbookData: [], totaldata: 0 });
        }
      })
   this.ExportApiCall();
  }









  ExportApiCall(page, rowsPerPage) {
    axios.get(localStorage.getItem('ISIurl') + 'ajaxreports.php?action=salestaxreport&fromdate=' +this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+ localStorage.getItem('ISIcmpid'))
      .then((resp) => {
        if (resp.data && resp.data.length > 0) {
        
          this.setState({
            ExportData: resp.data, 
           
          });
        } else {
          this.setState({ ExportData: [], totaldata: 0 });
        }
      })
   
  }









    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };


  myChangeHandler(event) {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({ [nam]: val });
  }



  handleClickSearch() {
   
	  this.apicall(this.state.page, this.state.rowsPerPage)
   
  }

  fromdatehandler(date) {
    var dateObj = new Date(date);
    this.setState({
      fromdate: dayjs(dateObj),
      fromdate1:
        dateObj.getFullYear() +
        '-' +
        (dateObj.getMonth() + 1) +
        '-' +
        dateObj.getDate(),
      fromDateEnabled: true,
    });
  }


  handleChangePage(event, newPage) {
    this.setState({ page: newPage }, () => {
      this.apicall(this.state.page, this.state.rowsPerPage);
    });
  }

  handleChangeRowsPerPage(event) {
    let pageval = event.target.value;
    this.setState({ rowsPerPage: parseInt(pageval), page: 0 }, () => {
      this.apicall(this.state.page, this.state.rowsPerPage);
    });
  }

  todatehandler(date) {
    var dateObj = new Date(date);
    this.setState({
      todate: dayjs(dateObj),
      todate1:
        dateObj.getFullYear() +
        '-' +
        (dateObj.getMonth() + 1) +
        '-' +
        dateObj.getDate(),
      toDateEnabled: true,
    });
  }

handleDownload = () => {
  const { ExportData } = this.state; 
  const doc = new jsPDF();

  
  const imgWidth = 40;  
  const imgHeight = 12; 
  const imgX = (doc.internal.pageSize.width - imgWidth) / 2; 
  const imgY = 10;      
   if (this.state.pdflogo) {
			 const logoImage = this.state.pdflogo.startsWith('data:image')
			  ? this.state.pdflogo
			  : `data:image/jpeg;base64,${this.state.pdflogo}`;
		  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
	 }


  const title = 'Sales Tax Report';
  doc.setFontSize(16);
  const titleY = imgY + imgHeight + 8;
  doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });

  const tableStartY = titleY + 10;


  const headers = [
    ['Invoice Number', 'Customer','Type', 'Taxable Value', 'Tax', 'Total']
  ];


  const rows = [];
  let GrandNetTotal = 0;

  ExportData.forEach(mainItem => {
    let strType = "";
    if (mainItem.salesincvoice === "1") {
      strType = "Sales Invoice";
      GrandNetTotal += Number(mainItem.total_amount) || 0;
    } else if (mainItem.salesincvoice === "2") {
      strType = "Sales Credit Note";
      GrandNetTotal -= Number(mainItem.total_amount) || 0;
    }

    rows.push([
      mainItem.sin_invoiceno || '',
      mainItem.cu_businessname || '',
      strType,
      Number(mainItem.taxablevalue || 0).toFixed(2),
      Number(mainItem.total_taxvalue || 0).toFixed(2),
      mainItem.salesincvoice === "2"
        ? `-${Number(mainItem.total_amount || 0).toFixed(2)}`
        : Number(mainItem.total_amount || 0).toFixed(2)
    ]);
  });

 
  if (ExportData.length > 0) {
    rows.push([
      '',
      '',
      '',
      'Grand Total',
      GrandNetTotal.toFixed(2)
    ]);
  }

 
  if (ExportData.length === 0) {
    rows.push([
      { content: 'No Records', colSpan: 5, styles: { halign: 'center' } }
    ]);
  }


  doc.autoTable({
    head: headers,
    body: rows,
    startY: tableStartY,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] }, 
    didDrawPage: function (data) {
      const str = "Page " + doc.internal.getNumberOfPages();
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    }
  });

  
  doc.save('SalesTaxReport.pdf');
};



 
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };
  
  
  
  
  
  
  

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
} 
	



  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }
let GrandNetTotal=0;
let GrandTaxTotal=0;

       const { salesbookData, showSummary, order, orderBy ,ExportData} = this.state;


    return (
      <React.Fragment>
        <div className="searchbox">
          <ul>
           
            
            <li>
              <p>From Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                   
                    value={this.state.fromdate ? dayjs(this.state.fromdate) : null} 
                    className="txtbox"
                    onChange={this.fromdatehandler}
                    format="MM/DD/YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            <li>
              <p>To Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                 
                    value={this.state.todate ? dayjs(this.state.todate) : null} 
                    className="txtbox"
                    onChange={this.todatehandler}
                    format="MM/DD/YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            
            <li>
              <p>&nbsp;</p>
              <p className="searchbutton">
                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                  Calculate
                </Button>
                &nbsp;
				
				  <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
				
				
				
				
				
				
                
              </p>
			  </li>
			
            
          </ul>
        </div>
        <div className="clear"></div>
        <div className="estimatebox">
          <Paper style={styles.root}>
            <TableContainer style={styles.container}>
              <Table stickyHeader aria-label="sticky table" >
                <TableHead>
                  <TableRow>
                  
                 
                    <TableCell>Invoice Number</TableCell>
                    <TableCell>Customer</TableCell>
					
					<TableCell>Type</TableCell>
                    <TableCell>Taxable Value</TableCell>
                    <TableCell>Tax</TableCell>
                    <TableCell>Total</TableCell>
                 
                  </TableRow>
                </TableHead>
			<TableBody>
  {stableSort(salesbookData, getSorting(order, orderBy)).map((mainItem, mainIndex) => {
    if (mainItem.salesincvoice === "1") {
      GrandNetTotal += Number(mainItem.total_amount) || 0;
    } else if (mainItem.salesincvoice === "2") {
      GrandNetTotal -= Number(mainItem.total_amount) || 0;
    }

    return (
      <TableRow key={mainIndex}>
        <TableCell>{mainItem.sin_invoiceno}</TableCell>
        <TableCell>{mainItem.cu_businessname}</TableCell>
		   <TableCell>
          {mainItem.salesincvoice === "1" ? "Sales Invoice" : "Sales Credit Note"}
        </TableCell>

        <TableCell>{'\u200B' + parseFloat(mainItem.taxablevalue || 0).toFixed(2)}</TableCell>

<TableCell>{'\u200B' + parseFloat(mainItem.total_taxvalue || 0).toFixed(2)}</TableCell>

<TableCell>
  {'\u200B' +
    (mainItem.salesincvoice === "2"
      ? `-${parseFloat(mainItem.total_amount || 0).toFixed(2)}`
      : parseFloat(mainItem.total_amount || 0).toFixed(2))}
</TableCell>
      </TableRow>
    );
  })}

  {salesbookData.length > 0 && (
    <TableRow>
      <TableCell></TableCell>
      <TableCell></TableCell>
	  <TableCell></TableCell>
      <TableCell style={{ fontWeight: 'bold' }}>Grand Total</TableCell>
      <TableCell style={{ fontWeight: 'bold' }}>
         {'\u200B' + parseFloat(GrandNetTotal || 0).toFixed(2)}
      </TableCell>
    </TableRow>
  )}

  {salesbookData.length === 0 && (
    <TableRow key="no-records">
      <TableCell align="center" colSpan={5}>No Records</TableCell>
    </TableRow>
  )}
</TableBody>





              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[50, 100, 150, 200]}
              component="div"
              count={this.state.totaldata}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Paper>
        </div>
		
		
		
		
		
      <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generate Sales Tax report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
					<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
	
						<ReactHTMLTableToExcel
						  variant="contained"
						  color="primary"
						  id="test-table-xls-button"
						  className="my-custom-excel-button"
						  table="salesbook"
						  filename="Sales Tax Report"
						  sheet="Sales Tax Report"
						  buttonText=""
						/>
                         <img
						src={psdfimage}
						width={100}
						height={100}
						style={{ cursor: "pointer" }}
						 onClick={this.handleClickOpen} 
						alt="Download PDF"
						/>
             </p>              
                    
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
				
				
				
				
			





<div style={{ textAlign: "center", padding: "20px",'display':'none' }}>


<img
  style={{ width: "200px", height: "100px" }}
  src={this.state.pdflogo} 
  alt="Company Logo"
/>

    <h2>Sales Tax Report</h2>

      <Table stickyHeader   aria-label="sticky table" id="salesbook" ref={this.tableRef}>
                <TableHead>
                  <TableRow>
                  
                 
                    <TableCell>Invoice Number</TableCell>
                    <TableCell>Customer</TableCell>
					<TableCell>Type</TableCell>
                    <TableCell>Taxable Value</TableCell>
                    <TableCell>Tax</TableCell>
                    <TableCell>Total</TableCell>
                    
                 
                  </TableRow>
                </TableHead>
			<TableBody>
  {ExportData.map((mainItem, mainIndex) => {
    if (mainItem.salesincvoice === "1") {
      GrandNetTotal += Number(mainItem.total_amount) || 0;
    } else if (mainItem.salesincvoice === "2") {
      GrandNetTotal -= Number(mainItem.total_amount) || 0;
    }

    return (
      <TableRow key={mainIndex}>
        <TableCell>{mainItem.sin_invoiceno}</TableCell>
        <TableCell>{mainItem.cu_businessname}</TableCell>
		 <TableCell>
          {mainItem.salesincvoice === "1" ? "Sales Invoice" : "Sales Credit Note"}
        </TableCell>
        <TableCell>{'\u200B' + parseFloat(mainItem.taxablevalue || 0).toFixed(2)}</TableCell>

<TableCell>{'\u200B' + parseFloat(mainItem.total_taxvalue || 0).toFixed(2)}</TableCell>

<TableCell>
  {'\u200B' +
    (mainItem.salesincvoice === "2"
      ? `-${parseFloat(mainItem.total_amount || 0).toFixed(2)}`
      : parseFloat(mainItem.total_amount || 0).toFixed(2))}
</TableCell>
      </TableRow>
    );
  })}

  {ExportData.length > 0 && (
    <TableRow>
      <TableCell></TableCell>
      <TableCell></TableCell>
	   <TableCell></TableCell>  <TableCell></TableCell>
      <TableCell style={{ fontWeight: 'bold' }}>Grand Total</TableCell>
      <TableCell style={{ fontWeight: 'bold' }}>
         {'\u200B' + parseFloat(GrandNetTotal || 0).toFixed(2)}
      </TableCell>
    </TableRow>
  )}

  {ExportData.length === 0 && (
    <TableRow key="no-records">
      <TableCell align="center" colSpan={5}>No Records</TableCell>
    </TableRow>
  )}
</TableBody>
 </Table>
</div>
			
				

      </React.Fragment>
    );
  }
}

  